import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import PhilosophySection from "./components/PhilosophySection";
import CourseFlowSection from "./components/CourseFlowSection";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

function CtaBanner() {
  const { t } = useTranslation("home");
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      style={{
        background: "#FAF5E8",
        padding: "100px 0",
      }}
    >
      <div
        className="max-w-6xl mx-auto px-6"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(24px)",
          transition: "opacity 0.9s ease, transform 0.9s ease",
        }}
      >
        <div
          style={{
            borderRadius: 24,
            background: "linear-gradient(135deg, #2C5F4F 0%, #3D7A63 100%)",
            padding: "64px 56px",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* Decorative circles */}
          <div
            style={{
              position: "absolute",
              top: -80,
              right: -80,
              width: 300,
              height: 300,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.06)",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: -60,
              left: -60,
              width: 240,
              height: 240,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.04)",
            }}
          />
          <p
            style={{
              fontFamily: "'Noto Sans JP', sans-serif",
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: "0.12em",
              color: "rgba(255,255,255,0.65)",
              textTransform: "uppercase",
              marginBottom: 16,
            }}
          >
            {t("cta.label")}
          </p>
          <h2
            style={{
              fontFamily: "'Noto Sans JP', sans-serif",
              fontWeight: 800,
              fontSize: "clamp(24px, 3vw, 36px)",
              color: "#ffffff",
              lineHeight: 1.5,
              marginBottom: 16,
            }}
          >
            {t("cta.heading")}
          </h2>
          <p
            style={{
              fontFamily: "'Noto Serif JP', serif",
              fontSize: 15,
              color: "rgba(255,255,255,0.8)",
              lineHeight: 1.9,
              maxWidth: 480,
              marginBottom: 40,
            }}
          >
            {t("cta.subtext")}
          </p>
          <Link
            to="/register"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            style={{
              padding: "14px 36px",
              borderRadius: 12,
              background: "#ffffff",
              color: "#2C5F4F",
              fontFamily: "'Noto Sans JP', sans-serif",
              fontWeight: 700,
              fontSize: 15,
              transition: "transform 0.2s, box-shadow 0.2s",
              boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
            }}
            onMouseEnter={(e) => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.transform = "translateY(-2px)";
              el.style.boxShadow = "0 8px 24px rgba(0,0,0,0.18)";
            }}
            onMouseLeave={(e) => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.transform = "translateY(0)";
              el.style.boxShadow = "0 4px 16px rgba(0,0,0,0.15)";
            }}
          >
            {t("cta.button")}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <PhilosophySection />
      <CourseFlowSection />
      <CtaBanner />
      <Footer />
    </main>
  );
}
